import React, { Component } from "react";
//import axios from "axios";

import "./home.css";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };

  }

  componentDidMount() {
  }

  render() {


    return (
      <div className="homePage">

        <h1 className="logo">
          {" "}
          Edelivery
      </h1>
      </div>
    );
  }
}


export default Home;
